import { GetComponentProps, styled } from 'topwrite';
import useConfig from '@@/use-config';
import { ReactNode, useState } from 'react';

export default function Float({ children }: GetComponentProps<'page'>) {

    const config = useConfig();
    const [show, setShow] = useState(true);
    const floatConfig = config.getValue('floatPage');
    let floatAd: ReactNode = null;
    if (show && floatConfig && floatConfig.text) {
        floatAd = <Container>
            <ImageContainer href={floatConfig.url} target='_blank'><img src={floatConfig.image} /></ImageContainer>
            <TextContainer href={floatConfig.url} target='_blank' dangerouslySetInnerHTML={{ __html: floatConfig.text }}></TextContainer>
            <CloseBtn onClick={() => setShow(false)} >
                <svg />
            </CloseBtn>
        </Container>;
    }

    return <>
        {floatAd}
        {children}
    </>;
}

const CloseBtn = styled.div`
    position: absolute;
    width: 46px;
    height: 46px;
    border-radius: 23px;
    right: -23px;
    bottom: -23px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &:hover{
        background: rgb(0 0 0/0.05);
    }

    svg{
        position: absolute;
        left: 10px;
        top: 10px;
        background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='7' fill='%23a6b7bf'%3E%3Cpath d='M.879.672L3 2.793 5.121.672a.5.5 0 11.707.707L3.708 3.5l2.12 2.121a.5.5 0 11-.707.707l-2.12-2.12-2.122 2.12a.5.5 0 11-.707-.707l2.121-2.12L.172 1.378A.5.5 0 01.879.672z'/%3E%3C/svg%3E") no-repeat;

    }
`;

const TextContainer = styled.a`
    color: inherit;
`;

const ImageContainer = styled.a`
    img{
        max-width: 100%;
    }
`;

const Container = styled.div`
    position: fixed;
    bottom: 10px;
    right: 10px;
    max-width: 180px;
    z-index: 1001;
    background-color: #f4f8fa;
    padding: 8px;
    min-height: 120px;
    display: flex;
    min-width: 150px;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    padding-bottom: 18px;
`;